import { ThirdRepository, PaginatedThirdsResult } from "../domain/ThirdRepository";

export interface SearchThirdsQueryParams {
  companyId: number;
  userId: number;
  text: string;
  thirdType: 'supplier' | 'customer';
  limit?: number;
  offset?: number;
}

export class SearchThirdsQuery {
  constructor(private readonly thirdRepo: ThirdRepository) {}

  execute(params: SearchThirdsQueryParams): Promise<PaginatedThirdsResult> {
    return this.thirdRepo.searchThirds(
      params.companyId,
      params.userId,
      params.text,
      params.thirdType,
      params.limit,
      params.offset
    );
  }
}
